import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { HelperService } from '../../../../services/helper.service';
import { CalculationResult } from '../../models/calculationModels/calculation-result';
import { IStress } from '../../models/stress.model';
import { DiagramDataModel } from '../../models';
import { GlobalEmittersService } from '../../../../services/global-emitters.service';
import { CalculationWarning } from '../../models/calculationModels/warning.model';
import { CalculationType } from '../../enums/calculation-type.enum';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-stress-factors-output',
    templateUrl: './stress-factors-output.component.html',
    styleUrls: ['./stress-factors-output.component.scss'],
    standalone: false,
})
export class StressFactorsOutputComponent implements OnInit, OnChanges {
    @Input() calcOutput: CalculationResult;
    @Input() diagramInfo: DiagramDataModel;

    generalTabIndex = 0;
    diagramInfoData: DiagramDataModel;
    isVisibleStressFactor: boolean;
    jointStress: IStress = {};
    boltStress: IStress = {};

    constructor(
        public helper: HelperService,
        private globalEmittersService: GlobalEmittersService,
        private cd: ChangeDetectorRef,
        private dataService: DataService
    ) {
        this.isVisibleStressFactor = true;
    }

    ngOnChanges(): void {
        this.setUpStressGaugeValue(this.generalTabIndex);
        this.isVisibleStressFactor = !(this.calcOutput?.output?.general?.warnings?.some((w: CalculationWarning): boolean => w.severity <= 1) ?? false);
    }

    ngOnInit(): void {
        this.globalEmittersService.isCalculationHappen.subscribe((res) => {
            if (res === true) {
                this.jointStress = {};
                this.setUpStressGaugeValue(0);
            }
        });

        this.dataService.isStandardCalcMode.subscribe((val) => {
            this.setUpStressGaugeValue(this.generalTabIndex);
        });

        this.setUpStressGaugeValue(this.generalTabIndex);
        this.isVisibleStressFactor = !(this.calcOutput?.output?.general?.warnings?.some((w: CalculationWarning): boolean => w.severity <= 1) ?? false);
    }

    // * Setting up stress gauge value
    setUpStressGaugeValue(index: number): void {
        this.jointStress = {};
        const input = this.calcOutput.input;
        const boltOutput = this.calcOutput.output.bolt;
        switch (index) {
            case 0:
                this.jointStress = {};

                if (input.calculationType == CalculationType.StandardFlange || input.calculationType == CalculationType.OverriddenFlange) {
                    if (!!this.dataService.selectedStandardCalcMode) {
                        this.jointStress.Min2Seal_percentage = parseFloat((boltOutput.minimumRequiredBoltStressPercentage * 100).toFixed(2));
                    }
                } else {
                    this.jointStress.Min2Seal_percentage = parseFloat((boltOutput.minimumRequiredBoltStressPercentage * 100).toFixed(2));
                }

                this.jointStress.Residual_percentage = parseFloat((boltOutput.residualBoltYieldPercentage * 100).toFixed(2));
                this.jointStress.Max_percentage = parseFloat((boltOutput.allowableBoltStressPercentage * 100).toFixed(2));
                this.jointStress.Min2Seal_value = boltOutput.minimumRequiredBoltStress;
                this.jointStress.Residual_value = boltOutput.residualBoltStress;
                this.jointStress.Max_value = boltOutput.maximumAllowableBoltStress;
                if (input.others.tighteningMethod == 1) {
                    this.jointStress.applied1_value = boltOutput.appliedBoltStress1;
                    this.jointStress.applied2_value = boltOutput.appliedBoltStress2;
                    this.jointStress.applied3_value = boltOutput.appliedBoltStress3;
                    this.jointStress.applied4_value = boltOutput.appliedBoltStress4;
                    this.jointStress.applied1_percentage = parseFloat((boltOutput.appliedBoltYieldPercentage1 * 100).toFixed(2));
                    this.jointStress.applied2_percentage = parseFloat((boltOutput.appliedBoltYieldPercentage2 * 100).toFixed(2));
                    this.jointStress.applied3_percentage = parseFloat((boltOutput.appliedBoltYieldPercentage3 * 100).toFixed(2));
                    this.jointStress.applied4_percentage = parseFloat((boltOutput.appliedBoltYieldPercentage4 * 100).toFixed(2));
                }
                this.cd.detectChanges();

                break;
            case 1:
                if (input.calculationType == CalculationType.StandardFlange || input.calculationType == CalculationType.OverriddenFlange) {
                    if (!!this.dataService.selectedStandardCalcMode) {
                        this.jointStress.Min2Seal_percentage = parseFloat((boltOutput.minimumRequiredBoltStressPercentage * 100).toFixed(2));
                    }
                } else {
                    this.jointStress.Min2Seal_percentage = parseFloat((boltOutput.minimumRequiredBoltStressPercentage * 100).toFixed(2));
                }

                this.jointStress.Residual_percentage = parseFloat((boltOutput.residualBoltYieldPercentage * 100).toFixed(2));
                this.jointStress.Max_percentage = parseFloat((boltOutput.allowableBoltStressPercentage * 100).toFixed(2));
                this.jointStress.Min2Seal_value = boltOutput.minimumRequiredBoltStress;
                this.jointStress.Residual_value = boltOutput.residualBoltStress;
                this.jointStress.Max_value = boltOutput.maximumAllowableBoltStress;
                if (input.others.tighteningMethod == 1) {
                    this.jointStress.applied1_value = boltOutput.appliedBoltStress1;
                    this.jointStress.applied2_value = boltOutput.appliedBoltStress2;
                    this.jointStress.applied3_value = boltOutput.appliedBoltStress3;
                    this.jointStress.applied4_value = boltOutput.appliedBoltStress4;
                    this.jointStress.applied1_percentage = parseFloat((boltOutput.appliedBoltYieldPercentage1 * 100).toFixed(2));
                    this.jointStress.applied2_percentage = parseFloat((boltOutput.appliedBoltYieldPercentage2 * 100).toFixed(2));
                    this.jointStress.applied3_percentage = parseFloat((boltOutput.appliedBoltYieldPercentage3 * 100).toFixed(2));
                    this.jointStress.applied4_percentage = parseFloat((boltOutput.appliedBoltYieldPercentage4 * 100).toFixed(2));
                }
                this.cd.detectChanges();

                break;
            case 2:
                break;

            case 3:
                break;
        }
    }

    onTabChanged($event: MatTabChangeEvent): void {
        this.generalTabIndex = $event.index;
        this.setUpStressGaugeValue($event.index);
    }
}
